<template>
  <uiv-modal
    ref="modal"
    v-bind="$attrs"
    v-on="$listeners"
    @show="confineFocus"
    @hide="releaseFocus"
    @keydown.native="wrapFocus">
    <template v-for="(_, name) in $scopedSlots" #[name]="scope">
      <slot :name="name" v-bind="scope"/>
    </template>
  </uiv-modal>
</template>

<script>
import { Modal } from 'uiv'
import { containFocus, uncontainFocus, wrapTabFocus } from '@/util/focus_containment'

export default {
  name: 'A11yModal',
  components: { 'uiv-modal': Modal },
  inheritAttrs: false,
  methods: {
    confineFocus() {
      this._inertedEls = containFocus(this.$refs.modal && this.$refs.modal.$el)
    },
    releaseFocus() {
      uncontainFocus(this._inertedEls)
      this._inertedEls = []
    },
    wrapFocus(event) {
      wrapTabFocus(event, this.$refs.modal && this.$refs.modal.$el)
    },
    toggle(...args) {
      return this.$refs.modal.toggle(...args)
    }
  },
  beforeDestroy() {
    this.releaseFocus()
  }
}
</script>
